import I18n from "../../I18n";
import { datetime, formatFileSize, date } from "../../utils";
import { stringifyFilter } from "colbi_web_ui/lib/utils";

function generateFindingColumn(submissionStatus, I18n, fiscalYear, id) {
    if (["success", "valid"].includes(submissionStatus)) {
        return {
            label: "hasFindings",
            value: {
                color: "green",
                name: I18n.translate`No`,
            },
            type: "colorize-link",
        };
    } else {
        if (["error", "invalid"].includes(submissionStatus)) {
            return {
                label: "hasFindings",
                value: {
                    id: "ncAudit",
                    color: "yellow",
                    name: I18n.translate`Yes`,
                    __typename: "AuditNavigation",
                    customParam: { fiscalYear: `${fiscalYear}`, importId: `${id}` },
                },
                type: "colorize-link",
            };
        }
    }
    return {
        label: "hasFindings",
        value: {
            name: "-",
        },
        type: "colorize-link",
    };
}

const getFileSubmissionStatus = (submissionStatus) => {
    
    switch (submissionStatus) {
        case "success":
            return {
                severity: 0,
                color: "main",
                family: "success",
                label: I18n.translate`data.file.saft.submited`,
            };

        case "valid":
            return {
                severity: 1,
                color: "main",
                family: "warning",
                label: I18n.translate`Ready to Submit`,
            };
        
        case "error":
            return {
                severity: 3,
                color: "main",
                family: "destructive",
                label: I18n.translate`error`,
            };
        
        case "invalid":
            return {
                severity: 3,
                color: "main",
                family: "destructive",
                label: I18n.translate`Invalid`,
            };

        case "processing":
        case "finished_validation":
        case "save_output":
        case "read_output":
        case "parse_output":
            return {
                severity: 1,
                color: "main",
                family: "warning",
                label: I18n.translate`In Progress`,
            };
        
        case "start_validation":
            return {
                severity: 1,
                color: "main",
                family: "warning",
                label: I18n.translate`start_validation`,
            }
        
        default:
            return {
                color: "300",
                family: "grey",
                severity: 4,
                label: I18n.translate`${submissionStatus ? submissionStatus : "To Submit"}`,
            };
    }
};

const mapCard = (json) => {
    const {
        name,
        uploadedAt,
        submittedBy,
        fiscalYear,
        type,
        subType,
        fileSizeDecompress,
        submissionStatus,
        startDate,
        endDate,
        id,
        fileSubmittedAt,
        fileSubmittedBy,
    } = json;

    const hasFindings = generateFindingColumn(submissionStatus, I18n, fiscalYear, id);

    return [
        [{ labels: ["file_name"], value: name, type: "string" }],
        [{ labels: ["fiscalYear"], value: fiscalYear, type: "string" }],
        [
            {
                labels: ["uploaded"],
                value: datetime(uploadedAt),
                type: "string",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["fileSizeDecompress"],
                value: formatFileSize(fileSizeDecompress),
                type: "number",
                mobileHidden: true,
                align: "center",
            },
        ],
        [
            {
                labels: ["type"],
                value: I18n.translate`${type}`,
                type: "string",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["subtype"],
                value: subType,
                type: "string",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["user"],
                value: submittedBy,
                type: "string",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["status"],
                value: {
                    ...getFileSubmissionStatus(submissionStatus),
                },
            },
        ],
        [
            {
                labels: ["start"],
                value: date(startDate),
                type: "datetime",
                mobileHidden: true,
                align: "left",
            },
        ],
        [
            {
                labels: ["end"],
                value: date(endDate),
                type: "datetime",
                mobileHidden: true,
                align: "left",
            },
        ],
        [
            {
                labels: ["requestName"],
                value: fileSubmittedBy,
                type: "string",
                mobileHidden: true,
                align: "left",
            },
        ],
        [
            {
                labels: ["requestAt"],
                value: datetime(fileSubmittedAt),
                type: "datetime",
                mobileHidden: true,
                align: "left",
            },
        ],
        [hasFindings],
        ["valid", "success", "imported"].includes(submissionStatus)
            ? [
                  {
                      labels: ["download"],
                      value: {
                          id,
                          name,
                          entity: "submission",
                          submissionStatus,
                          customComponent: "DownloadFile",
                      },
                      align: "center",
                  },
              ]
            : [
                  {
                      labels: ["download"],
                      value: {
                          value: "-",
                          customComponent: "TypographyWrapper",
                      },
                      align: "center",
                  },
              ],
    ];
};

const header = [
    { label: ["File"], align: "left", sortable: true, columnName: "CDM_DataFiles.Name" },
    {
        label: ["Fiscal Year"],
        align: "left",
        sortable: true,
        columnName: "CDM_DataFiles.FiscalYear",
    },
    {
        label: ["Uploaded at"],
        align: "left",
        sortable: true,
        columnName: "CDM_DataFiles.UploadedAT",
        mobileHidden: true,
    },
    { label: ["File Size"], align: "center", mobileHidden: true },
    { label: ["Type"], align: "left", mobileHidden: true },
    { label: ["Sub Type"], align: "left", mobileHidden: true },
    { label: ["Uploaded by"], align: "left", mobileHidden: true },
    { label: ["Status"], align: "center", type: "status" },
    { label: ["Start Date"], align: "left", mobileHidden: true },
    { label: ["End Date"], align: "left", mobileHidden: true },
    { label: ["Requested By"], align: "left", mobileHidden: true },
    { label: ["Requested At"], align: "left", mobileHidden: true },
    { label: ["Findings"], align: "center", type: "repoHasFindings" },
    { label: ["AT Response"], align: "center", type: "customComponent" },
];

const mapper = (json, card) => {
    const resType = json.type.toString().replace("File", "");
    return {
        ...json,
        id: json.id,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/submission_saft/${resType}/${json.id}?filter=${stringifyFilter(
                [{ column: "data_files.id", filters: [{ value: `${json.id}` }] }],
            )}`,
        },
    };
};

const datafilesubmissionatMapper = {
    map: mapper,
    header,
    showCheckbox: true,
};
export default datafilesubmissionatMapper;
